import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  commentList: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minHeight: "2em",
    overflowY: "auto",
    padding: "0px 24px 24px 24px",
    "&::-webkit-scrollbar": {
      width: "4px",
      borderRadius: "100px",
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
      borderRadius: "100px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: colors.gray500,
      borderRadius: "100px",
    },
  },

  content: {
    alignItems: "flex-start",
    background: colors.gray50,
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    flexWrap: "nowrap",
    width: "100%",
  },

  headline: {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0,
    gap: "8px",
    padding: "16px 24px",
  },

  headlineBadge: {
    alignItems: "center",
    background: colors.gray600,
    borderRadius: "100px",
    color: colors.white,
    display: "flex",
    flexDirection: "column",
    fontFamily: "Manrope",
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: 600,
    gap: "10px",
    letterSpacing: "0.5px",
    lineHeight: "16px",
    padding: "0px 4px",
    textAlign: "center",
    position: "relative",
    top: "2px",
  },

  headlineText: {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    letterSpacing: "0.15px",
    lineHeight: "24px",
    textAlign: "center",
  },

  loadMoreButtonContainer: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
}));

export default styles;
